import script from "./LogoPreviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LogoPreviewModal.vue?vue&type=script&setup=true&lang=js"

import "./LogoPreviewModal.vue?vue&type=style&index=0&id=2a166af2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a166af2"]])

export default __exports__